import { render, staticRenderFns } from "./toDiamond.vue?vue&type=template&id=2d08b018&scoped=true"
import script from "./toDiamond.vue?vue&type=script&lang=js"
export * from "./toDiamond.vue?vue&type=script&lang=js"
import style0 from "./toDiamond.vue?vue&type=style&index=0&id=2d08b018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08b018",
  null
  
)

export default component.exports